import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/packages/app/src/app/(client)/(authenticated)/layout.tsx");
